import { chamar } from '@/services/geo-engine/client';
/**
 * Chamadas administrativas de ingestão: autenticadas exclusivamente pela sessão
 * administrativa (`credencialAdministrativa`), nunca pelo `VIEWER_API_TOKEN` técnico.
 */
export function listarHistoricoDeIngestoes(token, opcoes = {}, sinal) {
    return chamar({
        metodo: 'GET',
        caminho: '/admin/ingestoes',
        autenticada: false,
        credencialAdministrativa: token,
        parametros: { limit: opcoes.limit, offset: opcoes.offset },
        sinal,
    });
}
export function consultarSituacaoDaIngestao(token, ingestionId, sinal) {
    return chamar({
        metodo: 'GET',
        caminho: `/admin/ingestoes/${encodeURIComponent(ingestionId)}`,
        autenticada: false,
        credencialAdministrativa: token,
        sinal,
    });
}
export function submeterIngestao(token, dados, sinal) {
    return chamar({
        metodo: 'POST',
        caminho: '/admin/ingestoes',
        autenticada: false,
        credencialAdministrativa: token,
        corpo: dados,
        sinal,
    });
}
export function listarCamadasAdmin(token, sinal) {
    return chamar({
        metodo: 'GET',
        caminho: '/admin/camadas',
        autenticada: false,
        credencialAdministrativa: token,
        sinal,
    });
}
export function excluirIngestao(token, ingestionId, sinal) {
    return chamar({
        metodo: 'DELETE',
        caminho: `/admin/ingestoes/${encodeURIComponent(ingestionId)}`,
        autenticada: false,
        credencialAdministrativa: token,
        sinal,
    });
}
